import { FC } from "react";
import { Route, Switch } from 'react-router-dom';
import ArchiveLearn from '../pages/archive/learn';
import ArchiveLearnCreate from '../pages/archive/learn/create';
import ArchiveLearnRead from '../pages/archive/learn/read';
import ArchiveLearnEdit from '../pages/archive/learn/edit';
import ArchiveManage from '../pages/archive/manage';
import ArchiveManageCreate from '../pages/archive/manage/create';
import ArchiveManageRead from '../pages/archive/manage/read';
import ArchiveManageEdit from '../pages/archive/manage/edit';
import ArchiveExam from '../pages/archive/exam';
import ArchiveExamRead from '../pages/archive/exam/read';

const ArchiveRouter: FC = () => {
  return (
    <Switch>
      <Route path='/archive/learn' exact component={ArchiveLearn} />
      <Route path='/archive/learn/create' exact component={ArchiveLearnCreate} />
      <Route path='/archive/learn/:archiveCode' exact component={ArchiveLearnRead} />
      <Route path='/archive/learn/:archiveCode/edit' exact component={ArchiveLearnEdit} />
      <Route path='/archive/manage' exact component={ArchiveManage} />
      <Route path='/archive/manage/create' exact component={ArchiveManageCreate} />
      <Route path='/archive/manage/:archiveCode' exact component={ArchiveManageRead} />
      <Route path='/archive/manage/:archiveCode/edit' exact component={ArchiveManageEdit} />
      <Route path='/archive/exam' exact component={ArchiveExam} />
      <Route path='/archive/exam/:examCode' exact component={ArchiveExamRead} />
    </Switch>
  )
}

export default ArchiveRouter;
